function preloadImages({ urls, delay = 0 }) {
  return Promise.all(
    urls.map(url => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = url;
        img.onload = () => {
          setTimeout(() => resolve(img), delay);
        };
        img.onerror = reject;
      });
    }),
  );
}

export default preloadImages;
